import { createAction } from 'redux-actions';
import axios from 'axios';
import { API_ENDPOINTS } from '../../constants/api';
import { fetchCurrentCart } from './get';

const actions = {
    update: createAction('CART.UPDATE_CART'),
    success: createAction('CART.UPDATE_CART_SUCCESS'),
    error: createAction('CART.UPDATE_CART_ERROR'),
}

/**
 * Remove the line item from the cart
 * Refer to https://shopify.dev/docs/themes/ajax-api/reference/cart
 * @param url
 * @param properties
 * @returns {Promise<any>}
 */
const updateCart = async (url, properties) => {
    try {
        const { data } = await axios.post(url, properties);
        return data;
    } catch(error) {
        throw new Error(error);
    }
}

/**
 * Updates the cart with new properties
 * @param data
 * @returns {function(...[*]=)}
 */
export const initializeUpdateCart = data => {
    return async dispatch => {
        dispatch(actions.update());
        const properties = { updates: data };

        try {
            await updateCart(API_ENDPOINTS.cart.update, properties);
            dispatch(actions.success());
            dispatch(fetchCurrentCart());
        } catch(error) {
            dispatch(actions.error(error));
        }
    }
}

export default actions;

